(function() {
  let reviews = [];
  let dataEl = document.getElementById('aura-reviews-data');
  if (dataEl) {
    try {
      reviews = JSON.parse(dataEl.textContent);
    } catch (e) {}
  }
  if (!reviews.length) return;

  function getRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
  }

  document.addEventListener('DOMContentLoaded', _ => {
     if (location.href.includes('clear-ppf')) return;
    let root = document.querySelector('.image-with-text__heading');
    let img = document.querySelector('.image-with-text__media').querySelector('img');
    let review = reviews[getRandomNumber(0, reviews.length-1)];
    root.parentNode.querySelector('p').innerText = review.text;
  
    let srcset = img.srcset.split(',');
    srcset.forEach((line, index) => {
      let [first, second] = line.split(' ');
      first = review.image.replace('https://', '//') + '&' + first.split('&')[1];
      srcset[index] = first + ' ' + second;
    });
    img.srcset = srcset.join(',');
  });
})();